import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const CHOIR_CONTENT_PATH = 'licenses.steps.businessInformation.forms.choir';

export const choirOrganizations = ['kor72', 'danskFolkekor', 'dasom', 'dsf', 'syng'] as const;
export type ChoirOrganization = (typeof choirOrganizations)[number];

export const choirSchema = BasicBusinessInformationSchema.extend({
  numberOfEventsPerYear: z
    .number({
      required_error: `${CHOIR_CONTENT_PATH}.numberOfEventsPerYear.validation.required`,
    })
    .int({ message: `${CHOIR_CONTENT_PATH}.numberOfEventsPerYear.validation.required` })
    .min(1, { message: `${CHOIR_CONTENT_PATH}.numberOfEventsPerYear.validation.required` }),
  organization: z.enum(choirOrganizations, {
    errorMap: () => ({
      message: `${CHOIR_CONTENT_PATH}.organization.validation.required`,
    }),
  }),
});

export type ChoirForm = z.infer<typeof choirSchema>;

export const createChoirDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Choir,
});

export const toPayloadChoir = (form: ChoirForm, wareNumber: number): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs().format('YYYY-MM-DD'),
    quantity: form.numberOfEventsPerYear ? form.numberOfEventsPerYear : 0,
  };
};
